export * from './src/ecom-v1-local-delivery-option-local-delivery-options.meta.js';
